import { AbstractControl, ValidationErrors } from "@angular/forms";

export class RegexList {
  public static phoneRegex = /^[0-9+-]+$/;
}
export class Utils {
  static getDni(cuitOrCuil:String): string {
    // Obtener el número de DNI del CUIT
    const dniCuit = cuitOrCuil.substring(2, 10);
    // Comparar el número de DNI del CUIT con el número de DNI proporcionado
    return dniCuit;
  }
}

export function noEmojisValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value ? String(control.value) : ''; // Asegúrate de que el valor sea una cadena
  const emojiRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g
  if (emojiRegex.test(value)) {
    return { noEmojis: true };
  }
  return null;
}